import React, { useEffect, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Editor } from 'react-draft-wysiwyg';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import { sanitizedMsg } from "../../../utils/htmlUtils";
import './ImageWithTextTemplate.scss';

// TODO Ajouter des contrôles
export default function  ImageWithTextTemplate(
    {
        initialHtml,
        onChange,
        setJsxContent,
        acceptSecondImage = true,
        triggerCleanFunction,
    }
) {

    const [editorState, setEditorState] = useState(() => {
        if (initialHtml) {

            const contentBlock = htmlToDraft(initialHtml);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            return EditorState.createWithContent(contentState);
        }
        return EditorState.createEmpty();
    });

    const [imageUrl, setImageUrl] = useState('');
    const [imageUrl2, setImageUrl2] = useState('');
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);

    // TODO certainement mieux à faire

    useEffect(() => {
        if (triggerCleanFunction) {
            triggerCleanFunction(handleCleanedAction);
        }
    }, [triggerCleanFunction]);

    const handleCleanedAction = () => {
        console.log("Action déclenchée par le parent!");

        if (imageUrl) {
            resetFileInput(1)
        }

        if (imageUrl2) {
            resetFileInput(2)
        }

        setEditorState(EditorState.createEmpty())
    };

    useEffect(() => {

        let jsx = null;

        if (editorState.getCurrentContent().hasText()) {

            jsx = <div className="image-text-container ">
                { imageUrl && (
                    <div className="wrap-left">
                        <img src={ imageUrl } alt={ 'image-article' } className="image"/>
                    </div>
                ) }
                <p
                    className="text"
                    dangerouslySetInnerHTML={ sanitizedMsg(draftToHtml(convertToRaw(editorState.getCurrentContent()))) }/>
                { imageUrl2 && (
                    <div className="wrap-right">
                        <img src={ imageUrl2 } alt={ 'image-article' } className="image"/>
                    </div>
                ) }
            </div>

        } else {
            console.log("big picture")

            jsx = <div className="image-text-container">
                {imageUrl && (
                    <img src={imageUrl} alt={'image-article'} className="center"/>
                )}

                {imageUrl2 && (
                    <img src={imageUrl2} alt={'image-article'} className="center"/>
                )}
            </div>
        }

        setJsxContent(jsx)

    }, [editorState, imageUrl, imageUrl2]);

    const handleImageChange = (e, imageNumber) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (imageNumber === 1) {

                    setImageUrl(e.target.result);
                } else {

                    setImageUrl2(e.target.result)
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleEditorChange = (newState) => {
        setEditorState(newState);
        onChange(draftToHtml(convertToRaw(newState.getCurrentContent())));
    };

    const resetFileInput = (imageNumber) => {
        if (imageNumber === 1) {
            fileInputRef1.current.value = '';
            setImageUrl(null);
        } else {
            fileInputRef2.current.value = '';
            setImageUrl2(null);
        }
    };

    return (
        <div className='template-container'>
            <div className="image-upload mb-3 row">
                <div className="col-lg-6">
                    <div className="d-flex align-items-center">
                        <div className="w-100 me-3">
                            <label htmlFor="formFile" className="form-label">
                                Charger une image (optionnel) :
                            </label>
                            <input
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="image/*"
                                ref={ fileInputRef1 }
                                onChange={ (e) => handleImageChange(e, 1) }
                            />
                        </div>

                        { imageUrl && (
                            <button
                                type="button"
                                className="btn btn-secondary btn-align"

                                onClick={ () => resetFileInput(1) }
                            >
                                Vider l&apos;image
                            </button>
                        ) }
                    </div>
                </div>
                { ((imageUrl || imageUrl2) && acceptSecondImage) && (
                    <div className="col-lg-6 d-flex align-items-center">
                        <div className="me-3">
                            <label
                                htmlFor="formFile2"
                                className="form-label">
                                Charger une image seconde image (optionnel) :
                            </label>
                            <input
                                className="form-control"
                                type="file" id="formFile2"
                                accept="image/*"
                                ref={ fileInputRef2 }
                                onChange={ (e) => handleImageChange(e, 2) }/>
                        </div>

                        { imageUrl2 && (
                            <button
                                type="button"
                                className="btn btn-secondary btn-align"

                                onClick={ () => resetFileInput(2) }
                            >
                                Vider l&apos;image
                            </button>
                        ) }
                    </div>
                ) }

            </div>

            <div className='my-3'>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={handleEditorChange}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                    toolbarStyle={{
                        border: "1px solid #ccc",
                        borderRadius: "0.313rem",
                    }}
                    hashtag={{
                        separator: ' ',
                        trigger: '#',
                    }}
                    toolbar={{
                        // image: {
                        //     uploadCallback: uploadImageCallBack,
                        //     previewImage: true,
                        //     alt: { present: true, mandatory: false },
                        //     alignmentEnabled: true,
                        //     inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                        //     defaultSize: {
                        //         height: '400',
                        //         width: 'auto',
                        //     },
                        //     urlEnabled: true,
                        //     uploadEnabled: true,
                        //     alignment: {
                        //         inDropdown: true,
                        //         options: ['left', 'center', 'right'],
                        //         // left: { className: 'image-left' },
                        //         // center: { className: '' },
                        //         // right: { className: 'image-right' },
                        //     },
                        // },
                        // history: {
                        //     visible: true,
                        //     undo: { visible: true },
                        //     redo: { visible: true },
                        // },
                        colorPicker: {
                            colors: [
                                'rgb(0, 0, 0)',
                                'rgb(33, 41, 130)',
                                'rgb(18, 66, 212)',
                                'rgb(191, 13, 84)',
                                'rgb(224, 76, 135)',
                                'rgb(109, 211, 206)',
                                'rgb(25, 154, 147)',
                                'rgb(242, 49, 49)',
                            ],
                        }
                    }}
                />
            </div>
        </div>
    );
}
